(function () {
    'use strict';

    angular.module('swif.framework')
    .config(function(IdleProvider, KeepaliveProvider, TitleProvider) {
        // configure Idle settings
        IdleProvider.idle(10); // in seconds
        KeepaliveProvider.interval(2); // in seconds
        TitleProvider.enabled(false); // disable tab title change when idle
    })
    .run(userIdleController);


    function userIdleController($q, $rootScope, swif, Idle) {
        $q.when(swif.settings.initialize()).then(function() {
            var timeoutDuration = swif.settings.app.features.timeoutDuration
            if (!timeoutDuration) { // feature disabled
                return
            }

            Idle.setTimeout(timeoutDuration)

            if (swif.user.isAuthenticated() && timeoutDuration) {
                var last_activity = swif.settings.get('last_activity')
                if (moment().diff(last_activity) >= moment.duration(timeoutDuration, 'seconds')) {
                    swif.user.logout();
                } else {
                    Idle.watch()
                }
            }

        })

        $rootScope.$on('IdleTimeout', function() {
            swif.user.logout();
        });

        $rootScope.$on('Keepalive', function() {
            swif.settings.set('last_activity', moment());
        });
    }
})();
